import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <h4>&#10003; VerificaIncentivi.it</h4>
            <p>La piattaforma italiana per scoprire tutti gli incentivi e le agevolazioni disponibili per la tua azienda.</p>
            <p style={{ marginTop: 12 }}>
              <strong style={{ color: 'white' }}>Consulentecrediti S.r.l.s.</strong><br />
              P.IVA 06139990870<br />
              Via Ravanusa N.13<br />
              95030 Tremestieri Etneo (CT)
            </p>
          </div>
          <div>
            <h4>Navigazione</h4>
            <p><Link to="/">Home</Link></p>
            <p><Link to="/incentivi">Catalogo Incentivi</Link></p>
            <p><Link to="/come-funziona">Come Funziona</Link></p>
            <p><Link to="/gestione-bandi">Gestione Bandi</Link></p>
            <p><Link to="/cessione-crediti">Cessione Crediti</Link></p>
            <p><Link to="/faq">FAQ</Link></p>
          </div>
          <div>
            <h4>Servizi</h4>
            <p><Link to="/register">Verifica Gratuita</Link></p>
            <p><Link to="/incentivi">42 Incentivi Disponibili</Link></p>
            <p><Link to="/gestione-bandi" style={{ color: '#22c55e' }}>Gestione Bandi Professionale</Link></p>
            <p><Link to="/cessione-crediti">Cessione Crediti Fiscali</Link></p>
            <p>Report Personalizzato</p>
          </div>
          <div>
            <h4>Contatti</h4>
            <p>Email: <a href="mailto:info@verificaincentivi.it">info@verificaincentivi.it</a></p>
            <p>PEC: <a href="mailto:consulentecrediti@legalmail.it">consulentecrediti@legalmail.it</a></p>
            <p>WhatsApp: <a href="https://wa.me/393484932900" target="_blank" rel="noopener noreferrer">+39 348 493 2900</a></p>
          </div>
        </div>
        <div className="footer-legal" style={{ borderTop: '1px solid rgba(255,255,255,0.15)', marginTop: '24px', paddingTop: '20px', textAlign: 'center' }}>
          <p style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '8px 20px', margin: '0 0 16px 0', fontSize: '0.9rem' }}>
            <Link to="/termini-e-condizioni" style={{ color: 'rgba(255,255,255,0.8)' }}>Termini e Condizioni</Link>
            <Link to="/privacy-policy" style={{ color: 'rgba(255,255,255,0.8)' }}>Privacy Policy</Link>
            <Link to="/cookie-policy" style={{ color: 'rgba(255,255,255,0.8)' }}>Cookie Policy</Link>
            <Link to="/disclaimer" style={{ color: 'rgba(255,255,255,0.8)' }}>Disclaimer</Link>
          </p>
        </div>
        <div style={{ textAlign: 'center', padding: '12px 0', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>
          <p style={{ margin: '0 0 4px 0' }}>Questo sito non fa parte di Facebook™ o Facebook™ Inc. Inoltre, questo sito NON è approvato da Facebook™ in alcun modo. Facebook™ è un marchio registrato di Facebook™ Inc.</p>
          <p style={{ margin: 0 }}>This Website is not a part of Facebook™ or Facebook™ Inc. Additionally, this site is NOT endorsed by Facebook™ in any way. Facebook™ is a trademark of Facebook™ Inc.</p>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Consulentecrediti S.r.l.s. - P.IVA 06139990870 - Tutti i diritti riservati</p>
        </div>
      </div>
    </footer>
  );
}
